import appHelpers from 'app/app-helpers';
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import rwRenderWidgetsTemplate from './rw-render-widgets.html';

const DIRTY_FORM = 'dashboard';

const mapStateToThis = (state) => ({
  isEditMode: state.dashboard.isEditMode,
});

const mapDispatchToThis = {
  setDirtyForm,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class RwRenderWidgetsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.asSortableOptions = {
      additionalPlaceholderClass: 'rw-dashboard-render-widgets-sortable-placeholder',
      dragMove: appHelpers.dragMove,
      itemMoved: () => {
        this.setDirtyForm(DIRTY_FORM, true);
      },
      orderChanged: () => {
        this.setDirtyForm(DIRTY_FORM, true);
      },
    };
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

class RwRenderWidgetsComponent {
  constructor() {
    this.template = rwRenderWidgetsTemplate;
    this.controller = RwRenderWidgetsController;
    this.bindings = {
      widgets: '=',
      widgetsConfig: '<',
      rowId: '<',
      isEditMode: '<',
      isDisabledShare: '<',
    };
  }
}

export default RwRenderWidgetsComponent;



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/rw-render-widgets/rw-render-widgets-component.js